module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_4_3.d4230680.jpeg";